import React, { useEffect, useState, useRef } from 'react';
import { X } from 'lucide-react';
// Sequence gets progressively slower, and stops before reaching 0
// Early: fast drops. Middle: slower. Below 10: very slow. Below 5: stops.
const buildSequence = () => {
  const seq: {
    delay: number;
    drop: number;
  }[] = [];
  // 47 → 35 (fast phase)
  seq.push({
    delay: 4000,
    drop: 2
  });
  seq.push({
    delay: 5000,
    drop: 1
  });
  seq.push({
    delay: 3000,
    drop: 3
  });
  seq.push({
    delay: 6000,
    drop: 1
  });
  seq.push({
    delay: 4000,
    drop: 2
  });
  seq.push({
    delay: 7000,
    drop: 1
  });
  seq.push({
    delay: 5000,
    drop: 2
  });
  // 35 → 20 (medium phase)
  seq.push({
    delay: 8000,
    drop: 2
  });
  seq.push({
    delay: 10000,
    drop: 1
  });
  seq.push({
    delay: 7000,
    drop: 2
  });
  seq.push({
    delay: 12000,
    drop: 1
  });
  seq.push({
    delay: 9000,
    drop: 2
  });
  seq.push({
    delay: 14000,
    drop: 1
  });
  seq.push({
    delay: 11000,
    drop: 1
  });
  seq.push({
    delay: 8000,
    drop: 2
  });
  seq.push({
    delay: 15000,
    drop: 1
  });
  // 20 → 10 (slow phase)
  seq.push({
    delay: 18000,
    drop: 1
  });
  seq.push({
    delay: 22000,
    drop: 1
  });
  seq.push({
    delay: 16000,
    drop: 2
  });
  seq.push({
    delay: 25000,
    drop: 1
  });
  seq.push({
    delay: 20000,
    drop: 1
  });
  seq.push({
    delay: 28000,
    drop: 1
  });
  seq.push({
    delay: 24000,
    drop: 1
  });
  seq.push({
    delay: 30000,
    drop: 1
  });
  // 10 → 5 (very slow phase)
  seq.push({
    delay: 35000,
    drop: 1
  });
  seq.push({
    delay: 45000,
    drop: 1
  });
  seq.push({
    delay: 40000,
    drop: 1
  });
  seq.push({
    delay: 55000,
    drop: 1
  });
  seq.push({
    delay: 50000,
    drop: 1
  });
  return seq;
};
const countdownSequence = buildSequence();
export function StickyTopBar() {
  const [isVisible, setIsVisible] = useState(true);
  const [remaining, setRemaining] = useState(47);
  const [flash, setFlash] = useState(false);
  const stepRef = useRef(0);
  const timerRef = useRef<ReturnType<typeof setTimeout> | null>(null);
  useEffect(() => {
    function scheduleNext() {
      // Stop completely if we've run out of sequence steps or remaining <= 5
      if (stepRef.current >= countdownSequence.length) return;
      const {
        delay,
        drop
      } = countdownSequence[stepRef.current];
      timerRef.current = setTimeout(() => {
        setRemaining(prev => {
          const next = prev - drop;
          // Never go below 5
          if (next <= 5) return 5;
          return next;
        });
        setFlash(true);
        setTimeout(() => setFlash(false), 600);
        stepRef.current++;
        // Only continue if we haven't reached the floor
        setRemaining(prev => {
          if (prev <= 5) return prev;
          scheduleNext();
          return prev;
        });
      }, delay);
    }
    scheduleNext();
    return () => {
      if (timerRef.current) clearTimeout(timerRef.current);
    };
  }, []);
  if (!isVisible) return null;
  return <div className="sticky top-0 left-0 w-full z-[9999] bg-[#FF0000] text-white font-sans flex items-center justify-center px-8 py-2 min-h-[50px] md:h-[50px] shadow-md" data-id="element-270">
      <div className="text-center text-xs md:text-sm font-bold leading-tight max-w-3xl" data-id="element-271">
        <span className="block md:inline" data-id="element-272">
          🔥 Launch Special: Only 200 copies at this price —{' '}
        </span>
        <span className={`inline-block md:ml-1 underline decoration-2 transition-all duration-300 ${flash ? 'scale-125 text-yellow-300' : 'scale-100 text-white'}`} data-id="element-273">
          {remaining} remaining.
        </span>
        <span className="block md:inline md:ml-1" data-id="element-274">
          {' '}
          Price jumps to $305 when they're gone.
        </span>
      </div>

      <button onClick={() => setIsVisible(false)} className="absolute right-2 md:right-4 p-1 hover:bg-white/20 rounded-full transition-colors" aria-label="Close banner" data-id="element-275">
        <X className="w-4 h-4 md:w-5 md:h-5" data-id="element-276" />
      </button>
    </div>;
}